module.exports = "/img/_/_/_/assets/images//book.png?0545d1768b46aeef2e32bc75c904fe7c";